import { render, staticRenderFns } from "./DrugCatalogue.vue?vue&type=template&id=35a862af&scoped=true&"
import script from "./DrugCatalogue.vue?vue&type=script&lang=js&"
export * from "./DrugCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./DrugCatalogue.vue?vue&type=style&index=0&id=35a862af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a862af",
  null
  
)

export default component.exports